/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ControllerResponse__40_UserAttributes_and__report_ids_number_Array__41__Array_ } from '../models/ControllerResponse__40_UserAttributes_and__report_ids_number_Array__41__Array_';
import type { ControllerResponse_AccessUser_Array_ } from '../models/ControllerResponse_AccessUser_Array_';
import type { ControllerResponse_null_ } from '../models/ControllerResponse_null_';
import type { ControllerResponse_number_or_null_ } from '../models/ControllerResponse_number_or_null_';
import type { ControllerResponse_OrganizationAttributes_or_null_ } from '../models/ControllerResponse_OrganizationAttributes_or_null_';
import type { ControllerResponse_string_ } from '../models/ControllerResponse_string_';
import type { ControllerResponse_UserAttributes_Array_ } from '../models/ControllerResponse_UserAttributes_Array_';
import type { Omit_OrganizationAttributes_id_ } from '../models/Omit_OrganizationAttributes_id_';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class UserService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns ControllerResponse_string_ Ok
     * @throws ApiError
     */
    public resendVerifyEmail(): CancelablePromise<ControllerResponse_string_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/user/resend_verify_email',
        });
    }
    /**
     * @param requestBody
     * @returns ControllerResponse_null_ Ok
     * @throws ApiError
     */
    public updateUserData(
        requestBody: {
            given_name?: string;
            family_name?: string;
        },
    ): CancelablePromise<ControllerResponse_null_> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/user/user',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ControllerResponse_OrganizationAttributes_or_null_ Ok
     * @throws ApiError
     */
    public getInvitation(): CancelablePromise<ControllerResponse_OrganizationAttributes_or_null_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/user/invitation',
        });
    }
    /**
     * @returns ControllerResponse_null_ Ok
     * @throws ApiError
     */
    public acceptInvitation(): CancelablePromise<ControllerResponse_null_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/user/accept_invitation',
        });
    }
    /**
     * @returns ControllerResponse_null_ Ok
     * @throws ApiError
     */
    public denyInvitation(): CancelablePromise<ControllerResponse_null_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/user/deny_invitation',
        });
    }
    /**
     * @returns ControllerResponse_UserAttributes_Array_ Ok
     * @throws ApiError
     */
    public listOrganizationMembers(): CancelablePromise<ControllerResponse_UserAttributes_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/user/organization_members',
        });
    }
    /**
     * @returns ControllerResponse__40_UserAttributes_and__report_ids_number_Array__41__Array_ Ok
     * @throws ApiError
     */
    public listOrganizationReportAccesses(): CancelablePromise<ControllerResponse__40_UserAttributes_and__report_ids_number_Array__41__Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/user/organization_report_accesses',
        });
    }
    /**
     * @param requestBody
     * @returns ControllerResponse_null_ Ok
     * @throws ApiError
     */
    public removeFromOrganization(
        requestBody: {
            transfer_user_id?: string;
            user_id: string;
        },
    ): CancelablePromise<ControllerResponse_null_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/user/remove_from_organization',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ControllerResponse_OrganizationAttributes_or_null_ Ok
     * @throws ApiError
     */
    public getOrganization(): CancelablePromise<ControllerResponse_OrganizationAttributes_or_null_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/user/organization',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns ControllerResponse_OrganizationAttributes_or_null_ Ok
     * @throws ApiError
     */
    public patchOrganization(
        id: number,
        requestBody: Omit_OrganizationAttributes_id_,
    ): CancelablePromise<ControllerResponse_OrganizationAttributes_or_null_> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/user/organization',
            query: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns ControllerResponse_OrganizationAttributes_or_null_ Ok
     * @throws ApiError
     */
    public invitePeople(
        requestBody: {
            emails: Array<string>;
        },
    ): CancelablePromise<ControllerResponse_OrganizationAttributes_or_null_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/user/invite_people',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param seats
     * @returns any Ok
     * @throws ApiError
     */
    public seatUpdateInvoice(
        seats: number,
    ): CancelablePromise<{
        data: {
            amount_due: number;
            total: number;
            discount: {
                name?: string | null;
                amount: number;
            } | null;
            subtotal: number;
        } | null;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/user/seat_update_invoice',
            query: {
                'seats': seats,
            },
        });
    }
    /**
     * @param email
     * @returns ControllerResponse_number_or_null_ Ok
     * @throws ApiError
     */
    public resendInviteEmail(
        email: string,
    ): CancelablePromise<ControllerResponse_number_or_null_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/user/resend_invite_email',
            query: {
                'email': email,
            },
        });
    }
    /**
     * @returns ControllerResponse_AccessUser_Array_ Ok
     * @throws ApiError
     */
    public getPeopleInOrgOrShared(): CancelablePromise<ControllerResponse_AccessUser_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/user/recent_people',
        });
    }
}
